export const toCurrency = (currency: string): "USD" | "EUR" => {
  if (currency === "USD") return "USD";
  if (currency === "EUR") return "EUR";
  return "USD";
};
